export function isPrimitiveList(
  arr: unknown[],
): arr is Array<string | number | boolean> {
  return (
    Array.isArray(arr) &&
    arr.length > 0 &&
    ['string', 'number', 'boolean'].includes(typeof arr[0])
  );
}
